import React from "react";
import { Box, Typography, Avatar } from "@mui/material";

interface AppDataGridEmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
}

export const AppDataGridEmptyState: React.FC<AppDataGridEmptyStateProps> = ({
  icon,
  title = "Nenhum dado encontrado",
  description = "Não há registros para exibir no momento.",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        px: 3,
        textAlign: "center",
        fontFamily: "var(--font-sans)",
      }}
    >
      {icon && (
        <Avatar
          sx={{
            bgcolor: "grey.200",
            color: "grey.500",
            width: 80,
            height: 80,
            mb: 3,
          }}
        >
          {icon}
        </Avatar>
      )}
      <Typography
        variant="h6"
        component="p"
        sx={{ fontWeight: "bold", color: "text.primary" }}
      >
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {description}
      </Typography>
    </Box>
  );
};